export const labels = {
	colors: {
		label: "Label.MobileCreator.BottomMenu.Background.Colors",
		default: "Colors",
	},
	patterns: {
		label: "Label.MobileCreator.BottomMenu.Background.Patterns",
		default: "Patterns",
	},
} as const;
